import { ToggleChipOption } from 'src/routes/onboarding/setup/components/ToggleChipGroup';

export const CLIENT_TYPE_OPTIONS: ToggleChipOption[] = [
  { label: 'Companies', icon: 'Building', value: 'company' },
  { label: 'Individuals', icon: 'Profile', value: 'individual' },
];

export const CLIENT_COUNT_OPTIONS: ToggleChipOption[] = [
  { label: 'None', value: '0' },
  { label: '1 - 10', value: '10' },
  { label: '11 - 100', value: '100' },
  { label: '101 - 250', value: '250' },
  { label: '251 - 1,000', value: '1000' },
  { label: '1,001+', value: '1001+' },
];

export const COMPANY_REVENUE_OPTIONS: ToggleChipOption[] = [
  { label: '0 - $25K', value: '0_25K' },
  { label: '$25K - $100K', value: '25K_100K' },
  { label: '$100K - $250K', value: '100K_250K' },
  { label: '$250K - $1M', value: '250K_1M' },
  { label: '$1M - $10M', value: '1M_10M' },
  { label: '$10M+', value: '10M+' },
];
